import { render, staticRenderFns } from "./DoctorAccept.vue?vue&type=template&id=0873f74d&scoped=true"
import script from "./DoctorAccept.vue?vue&type=script&lang=js"
export * from "./DoctorAccept.vue?vue&type=script&lang=js"
import style0 from "./DoctorAccept.vue?vue&type=style&index=0&id=0873f74d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0873f74d",
  null
  
)

export default component.exports